import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useAdvertiser } from "@redux/advertiser";

const AdvertiserSelect = ({ selectAd, onAdver }) => {
  const advertiser = useAdvertiser();
  const [list, setList] = useState(null);

  useEffect(() => {
    advertiser.list((data, response) => {
      if (response.status === 200 && data.error === undefined) {
        setList(data.result);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {list && (
        <FormControl fullWidth>
          <Select
            labelId="ad_type"
            id="ad_type"
            align="left"
            size="small"
            sx={{ height: 41 }}
            value={selectAd}
            onChange={onAdver}
          >
            {list.map((data, index) => (
              <MenuItem value={data.code} key={data._id}>
                <Typography variant="body" color="grey.900" fontWeight={400}>
                  {data.name}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default AdvertiserSelect;
